import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OptionsTypeSelector } from '../../../../../models/options-type-selector';
import { ITransportConfiguration } from '../../../../../models/transport-configuration.model';
import { Transport } from '../../../../../models/transport.model';
import { TranslateService } from '@ngx-translate/core';
import { FaDirectiveEnum } from '../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-loading-constraint',
  templateUrl: './loading-constraint.component.html',
  styleUrls: ['./loading-constraint.component.scss'],
})
export class LoadingConstraintComponent implements OnChanges, OnInit {
  readonly #translateService = inject(TranslateService);

  @Input() transport?: Transport;
  @Input() config?: ITransportConfiguration;
  @Input() options: { isPickup: boolean } = { isPickup: true };
  @Input() control = new FormControl('');

  @Output() selectedLoadingConstraint = new EventEmitter<string>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  public loadingConstraints: OptionsTypeSelector[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (change === 'config') {
        this.filteringOptions(changes['config'].currentValue);
      }
    }
  }

  public ngOnInit(): void {
    this.filteringOptions(this.config);
  }

  public getVehicleData(): string | null {
    return (this.transport?.items || [])
      .filter(item => item.vehicleCategory && item.vehicleType)
      .map(item => `${this.#translateService.instant(item.vehicleCategory!.labelKey)} - ${this.#translateService.instant(item.vehicleType!.labelKey)}`)
      .join(' | ');
  }

  public filteringOptions(config?: ITransportConfiguration): void {
    if (!config) {
      this.loadingConstraints = OptionsTypeSelector.LOADING_CONSTRAINT;
    } else {
      const loadingConstraintValues = OptionsTypeSelector.LOADING_CONSTRAINT.reduce((values, loadingConstraint) => {
        values.push(loadingConstraint.value);
        return values;
      }, [] as string[]);

      this.loadingConstraints = config.loadingConstraints
        .filter(constraint => loadingConstraintValues.indexOf(constraint) !== -1)
        .map(constraint => OptionsTypeSelector.LOADING_CONSTRAINT[loadingConstraintValues.indexOf(constraint)]);
    }
    if (!this.control.value) {
      this.selectedLoadingConstraint.emit(this.loadingConstraints[0].value);
    }
  }

  switchCase<T>(pickupVal: T, deliveryVal: T): T {
    return this.options.isPickup ? pickupVal : deliveryVal;
  }
}
